// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2pb4K","content":"GlobalSearch_content__2FIH9"};